module.exports = __webpack_public_path__ + "img/Picture13.3fe3f974.jpg";